import React from 'react';
import _get from 'lodash/get';
import PlatformFooter from 'cccisd-footer';
import { Link } from 'cccisd-react-router';
import { Html } from 'cccisd-wysiwyg';
import instaIcon from './insta.svg';
import style from './style.css';
import { publicLinks, wpUrl } from '../NavBar';

const Appdefs = window.cccisd.appDefs;

const Footer = () => {
    const grantAttribution = _get(Appdefs, 'app.footer.grantAttribution', '');
    const contactUrl = _get(Appdefs, 'app.footer.contactUsLink', 'https://3cisd.com/?r=aspen.test%2F#ccc-lets-talk');

    return (
        <>
            <div className={style.upper}>
                <div className="container">
                    <div className={'d-flex flex-wrap justify-content-between ' + style.flex}>
                        <div>
                            <div>
                                <Html content={grantAttribution} />
                            </div>
                        </div>
                        <div className={'d-flex ' + style.flex2}>
                            <div>
                                <h5 className={style.headingLink}>
                                    <a href={contactUrl}>Contact Us</a>
                                </h5>
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <a
                                            href="https://www.instagram.com/freshtracks_/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={instaIcon} className={style.instaIcon} alt="Instagram" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="list-unstyled">
                                    {publicLinks.map(link => (
                                        <li className={'mb-1 ' + style.headingLink} key={link.label}>
                                            {link.url.startsWith(wpUrl) ? (
                                                <a href={link.url}>{link.label}</a>
                                            ) : (
                                                <Link to={link.url}>{link.label}</Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.lower}>
                <PlatformFooter grantAttribution="" />
            </div>
        </>
    );
};

export default Footer;
